import { Image } from '@belong/ui';
import clsx from 'clsx';
import { Text } from 'design-system';

type TipBoxProps = {
  title: string;
  description: string | string[];
  descriptionImages?: string[];
};

export function TipBox({
  title,
  description,
  descriptionImages = [],
}: TipBoxProps) {
  const localDescription = Array.isArray(description)
    ? description
    : [description];

  return (
    <div className="rounded border border-gray px-sm pb-xl pt-sm lg:max-w-[350px] lg:border-solid">
      <div
        className={clsx(
          'flex items-center',
          descriptionImages.length > 0 ? 'mb-lg' : 'mb-sm',
        )}
      >
        <Image
          src="/icons/icon-tip.svg"
          className="mr-xs h-md w-2sm object-contain"
          alt=""
        />
        <Text as="h3" fontWeight="semibold">
          {title}
        </Text>
      </div>
      {localDescription.map((text, index) => {
        if (descriptionImages[index]) {
          return (
            <div className="mt-xs flex items-center gap-sm" key={text}>
              <Image
                alt=""
                src={descriptionImages[index]}
                className="h-xl w-xl"
              />
              <Text as="p">{text}</Text>
            </div>
          );
        }

        return (
          <Text as="p" key={text} className="mt-xs">
            {text}
          </Text>
        );
      })}
    </div>
  );
}
